var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 375,
    viewBox: "0 0 372 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1404_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.1 340.9H35.8C24.5 340.9 15.3 331.7 15.3 320.4V78.1H307.6V104.3H322.9V27.3C322.9 12.2 310.7 0 295.6 0H27.3C12.2 0 0 12.2 0 27.3V328.8C0 343.9 12.2 356.1 27.3 356.1H295.5C301.7 356.1 307.5 354 312 350.5L298.6 337.1C295.4 339.5 291.4 340.9 287.1 340.9ZM15.3 27.3C15.3 20.7 20.7 15.3 27.3 15.3H295.5C302.1 15.3 307.5 20.7 307.5 27.3V62.8H15.3V27.3Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 32.2H72.1C67.9 32.2 64.5 35.6 64.5 39.8C64.5 44 67.9 47.4 72.1 47.4H74.3C78.5 47.4 81.9 44 81.9 39.8C81.9 35.6 78.5 32.2 74.3 32.2Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 32.2H43.1C38.9 32.2 35.5 35.6 35.5 39.8C35.5 44 38.9 47.4 43.1 47.4H45.3C49.5 47.4 52.9 44 52.9 39.8C52.9 35.6 49.6 32.2 45.3 32.2Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2 32.2H101C96.7999 32.2 93.3999 35.6 93.3999 39.8C93.3999 44 96.7999 47.4 101 47.4H103.2C107.4 47.4 110.8 44 110.8 39.8C110.8 35.6 107.5 32.2 103.2 32.2Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1 104.3H100.5C85.4 104.3 73.2 116.5 73.2 131.6V289C73.2 304.1 85.4 316.3 100.5 316.3H277.8L336.5 375V316.3H344.1C359.2 316.3 371.4 304.1 371.4 289V131.6C371.4 116.6 359.2 104.3 344.1 104.3ZM356.2 289C356.2 295.6 350.8 301 344.2 301H336.6H321.3V316.3V338.1L288.7 305.5L284.2 301H277.9H100.5C93.9 301 88.5 295.6 88.5 289V131.6C88.5 125 93.9 119.6 100.5 119.6H344.1C350.7 119.6 356.1 125 356.1 131.6V289H356.2Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4 242.9H183L174.7 156.7H155.5L147.1 242.9H146.8L139 156.7H122L133.3 268.9H156.8L164.8 193.2H165.1L173.1 268.9H195.1L206.5 156.7H191.2L183.4 242.9Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.4 268.9H263.5V252.9H233.1V218.4H257.3V202.4H233.1V172.7H263.5V156.7H215.4V268.9Z",
    fill: "#2D2D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 209.3V209C322.9 205.8 326.4 198.6 326.4 187V182.5C326.4 165.2 318.5 156.7 300.3 156.7H273.7V268.9H301.4C319 268.9 328.2 259.6 328.2 242.3V232.7C328.1 220.8 324.4 212.5 315 209.3ZM291.3 172.7H299.8C306.1 172.7 308.8 176.2 308.8 184.2V190.5C308.8 199.5 304.8 202.4 298.2 202.4H291.3V172.7ZM310.5 241.8C310.5 250.1 307.3 252.9 301.4 252.9H291.3V218.4H299.2C307.2 218.4 310.6 221.6 310.6 232V241.8H310.5Z",
    fill: "#2D2D95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1404_1579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 371.4,
    height: 375,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/Web.d21ff684.svg";
export { ForwardRef as ReactComponent };